'use client';
import { useContext, createContext } from 'react';

const TableHeadContext = createContext(false);
TableHeadContext.displayName = 'TableHeadContext';
const useTableHeadContext = ()=>useContext(TableHeadContext);

export { TableHeadContext, useTableHeadContext };
